// @flow

import { BaseService } from "./base-service";
import { FetchApi } from "../model/fetch";

type LoginResultSuccess = {
    redirectUrl?: string
};

export class LoginService extends BaseService {
    constructor(
        fetchApi: FetchApi,
        options: {
            basepath: string
        }
    ) {
        super(fetchApi, options);
    }
    recover = async (email: string): Promise<void> => {
        return await this.post("/api/forgotpassword", null, {
            email
        });
    };
    login = async (
        email: string,
        password: string
    ): Promise<LoginResultSuccess> => {
        return await this.post("/api/login/refurl", null, {
            email,
            password
        });
    };
}
